import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export default function Courses() {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [joinedCourses, setJoinedCourses] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const { t } = useTranslation("global");
  const [isLoading, setIsLoading] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userDataLogin"));
  const token = userData?.token;
  const lang = localStorage.getItem("lang")?.replace(/"/g, "") || "en";

  useEffect(() => {
    fetchCourses(currentPage);
    if (token && userData?.user?.type !== "student") {
      fetchJoinedCourses();
    }
  }, [currentPage]);

  const fetchCourses = async (page) => {
    const endpoint = token
      ? `${process.env.REACT_APP_API_URL}/courses?page=${page}`
      : `${process.env.REACT_APP_API_URL}/random_course?page=${page}`;

    try {
      const response = await fetch(endpoint, {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          "Accept-Language": lang,
        },
      });

      const result = await response.json();
      setCourses(result?.data || []);
      setPagination(result?.pagination || {});
    } catch (error) {
      console.error("Error fetching courses:", error);
      toast.error("An error occurred while fetching courses.");
    }
  };

  const fetchJoinedCourses = async () => {
    if (userData?.user?.type === "student") return;
  
    setIsLoading(true); // ابدأ التحميل
  
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/joint_course`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": lang,
          },
        }
      );
      const result = await response.json();
      setJoinedCourses(result?.data || []);
    } catch (error) {
      console.error("Error fetching joined courses:", error);
      toast.error("An error occurred while fetching joined courses.");
    } finally {
      setIsLoading(false); // انتهى التحميل
    }
  };
  

  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.last_page) {
      setCurrentPage(page);
    }
  };

  const handleCardClick = async (course) => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/payment_course/${course.id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (course.type === "free") {
        if (result?.code === 200 || result?.status === 200) {
          navigate(`/CourseDetails/${course.id}`);
          toast.success(result.message || "تم عرض الكورس المجاني بنجاح");
        } else {
          toast.error(result.message || "فشل عرض الكورس المجاني");
        }
      } else if (course.type === "paid") {
        if (course.purshed === 1) {
          navigate(`/CourseDetails/${course.id}`);
          toast.success("تم عرض الكورس المدفوع بنجاح");
        } else {
          if (result?.redirect_url) {
            window.location.href = result.redirect_url;
          } else {
            console.error("Redirect URL Missing:", result);
            toast.error(result.message || "فشل بدء الدفع للكورس المدفوع");
          }
        }
      }
    } catch (error) {
      toast.error("حدث خطأ أثناء محاولة الاشتراك في الكورس");
      console.error("Error:", error);
    }
  };

  return (
    <>
      <div className="custom-section">
        <div className="container">
          <h1 className="mb-1">{t('header.courses')}</h1>
          <h6 className="m-0">
            <Link className="link-hover" to="/">{t('header.home')}</Link>
            <span> - </span>
            <span className="second-color">{t('header.courses')}</span>
          </h6>
        </div>
      </div>

      <section className="container my-5">
        <div className="container mt-5">
        <div className="row justify-content-center">
  {isLoading ? (
    <p className="text-center fs-5 fw-bold">{t("loading")}</p>
  ) : (
    [...joinedCourses, ...courses].map((course, index) => {
      let courseImage = "";
      try {
        const images = JSON.parse(course.image);
        courseImage = images[0];
      } catch {
        courseImage = course.image;
      }

      const instructor = course.instructors?.[0];

      return (
        <div
          key={course.id || index}
          className="col-md-4"
          onClick={() => handleCardClick(course)}
          style={{ cursor: "pointer" }}
        >
          <div className="card custom-card">
            <img src={courseImage} alt="Course" className="card-img img-instructor" />
            <div className="card-body">
              <div className="card-info mt-1">
                <span>
                  <i className="bi bi-journal-text paragraph-color me-2 mx-2"></i>
                  {course.lessons} {t('onlineCourses2.lessons')}
                </span>
              </div>
              <h3 className="card-title">{course.name}</h3>
              {instructor && (
                <div className="card-instructor">
                  <img src={instructor.image} alt={instructor.name} />
                  <span>{instructor.name}</span>
                </div>
              )}
              <div className="card-footer">
                <span className="price">
                  {course.type === "free" ? t('free') : course.price}
                </span>
                <span className="details">
                  {course.type === "free"
                    ? t('join')
                    : course.purshed === 1
                      ? t('join')
                      : t('subscribe')}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    })
  )}
</div>


          {/* Pagination Section */}
          {pagination?.total > 0 && (
            <nav aria-label="Page navigation example">
              <ul className="pagination justify-content-center mt-4">
                <li className={`page-item ${pagination.current_page === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                    Prev
                  </button>
                </li>

                {Array.from({ length: pagination.last_page }, (_, index) => (
                  <li
                    key={index}
                    className={`page-item ${pagination.current_page === index + 1 ? "active" : ""}`}
                  >
                    <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                      {index + 1}
                    </button>
                  </li>
                ))}

                <li className={`page-item ${pagination.current_page === pagination.last_page ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </section>
    </>
  );
}
